<template>
  <div :id="attachId" class="attach-container">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :transition="false"
      offset-y
      :attach="`#${attachId}`"
      min-width="300"
      max-width="400"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          class="datearray-selector sv-autocomplete"
          :class="{ 'datearray-selector--error': errorMessages.length > 0 }"
          v-on="on"
        >
          <v-chip
            v-for="(date, index) in datesSorted"
            :key="index"
            small
            close
            class="ma-1"
            @click:close="dateRemove(date)"
            >{{ dateFormat(date) }}</v-chip
          ><span v-if="dates.length == 0" class="datearray-hint mx-2"
            >Нажмите, чтобы выбрать даты</span
          >
        </div>
      </template>
      <v-date-picker
        v-model="dates"
        multiple
        no-title
        scrollable
        width="100%"
        :first-day-of-week="1"
        color="primary"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <div v-if="errorMessages.length" class="error--text">
      {{ errorMessages.join(". ") }}
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    attachId: {
      type: String,
      default: "dtarray"
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    dates: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    datesSorted() {
      const ar = [...this.dates];
      ar.sort();
      return ar;
    }
  },
  methods: {
    dateFormat(date) {
      return date ? moment(date).format("DD.MM.yyyy") : "";
    },
    dateRemove(date) {
      const ar = this.dates.filter(dt => dt !== date);
      this.$emit("input", ar);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/branding.scss";
.datearray-selector {
  border: 1px solid $brand-control-border;
  min-height: 40px;
  padding: 6px 4px 2px 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 3px;
}
.datearray-hint {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
}
.attach-container {
  position: relative;
}
.datearray-selector--error {
  border: 2px solid #ff5252;
}
</style>
